import React from "react";
import { dateRange } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function MagazineCoverTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl p-8 shadow-2xl text-[13px] leading-relaxed" data-testid="resume-live-preview">
      <p className="text-[11px] font-bold uppercase tracking-[0.3em]" style={{ color: accent }}>{draft.target_role || "Resume"}</p>
      <h1 className="text-5xl font-black tracking-tight -mt-1 mb-2">{draft.full_name || "Your Name"}</h1>
      <p className="text-slate-500 text-[11px] mb-4">{[draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).join("  •  ")}</p>
      <div className="w-full h-1 mb-5" style={{ backgroundColor: accent }} />

      {draft.summary && <p className="text-slate-700 mb-4 text-[14px] italic">{draft.summary}</p>}

      {draft.experience.length > 0 && (
        <div className="mb-4">
          <h2 className="text-xs font-bold uppercase tracking-wider mb-2" style={{ color: accent }}>Experience</h2>
          {draft.experience.map((e, i) => (
            <div key={i} className="mb-2.5">
              <p className="font-semibold text-slate-800">{e.title} — {e.company} <span className="text-slate-400 font-normal italic">({dateRange(e.start_date, e.end_date, e.current)})</span></p>
              <ul className="list-disc list-inside text-slate-700 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
            </div>
          ))}
        </div>
      )}
      {draft.education.length > 0 && (
        <div className="mb-4">
          <h2 className="text-xs font-bold uppercase tracking-wider mb-2" style={{ color: accent }}>Education</h2>
          {draft.education.map((ed, i) => <p key={i} className="text-slate-700">{ed.degree} {ed.field} — {ed.school}</p>)}
        </div>
      )}
      {draft.skills.length > 0 && (
        <div className="mb-4">
          <h2 className="text-xs font-bold uppercase tracking-wider mb-2" style={{ color: accent }}>Skills</h2>
          <p className="text-slate-700">{draft.skills.join(", ")}</p>
        </div>
      )}
      <ExtraResumeSections draft={draft} accent={accent} />
    </div>
  );
}
